import { c as _c } from "react/compiler-runtime";
import { useFunnelLeads } from 'modules/funnels/funnel/hooks/use-funnel-leads';
import { FunnelLeadsInterface } from 'modules/funnels/funnel/types/funnel-leads-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { Hint } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { RelativeTime } from 'shared/components/relative-time';
import { MobileCardHeader } from 'shared/components/table/components/mobile-card-header';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import ContactInfoTooltip from 'shared/components/tooltip/contact-info-tooltip';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
interface LeadsTabProps {
  funnelId: FunnelId;
}
interface LeadEmailProps {
  lead: FunnelLeadsInterface;
  withContactInfo: boolean;
}
function LeadEmail(t0) {
  const $ = _c(9);
  const {
    lead,
    withContactInfo
  } = t0;
  const t1 = `/contacts/${lead.contact.id}`;
  let t2;
  if ($[0] !== lead.contact.email || $[1] !== t1) {
    t2 = <LinkWithoutPrefetch className="link inline-block w-fit max-w-full truncate" href={t1}>{lead.contact.email}</LinkWithoutPrefetch>;
    $[0] = lead.contact.email;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const link = t2;
  if (!withContactInfo || !lead.customer) {
    return link;
  }
  const t3 = lead.customer?.referredBy?.email;
  const t4 = lead.customer?.referredBy?.connectedUser?.id;
  let t5;
  if ($[3] !== lead.customer.fieldValues || $[4] !== lead.customer.type || $[5] !== link || $[6] !== t3 || $[7] !== t4) {
    t5 = <ContactInfoTooltip fields={lead.customer.fieldValues} referredByEmail={t3} type={lead.customer.type} contactId={t4}>{link}</ContactInfoTooltip>;
    $[3] = lead.customer.fieldValues;
    $[4] = lead.customer.type;
    $[5] = link;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function LeadsTab(t0) {
  const $ = _c(57);
  const {
    funnelId
  } = t0;
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  const {
    t
  } = useLocoTranslation();
  const {
    isWsAssistant
  } = useUser();
  let t1;
  if ($[0] !== funnelId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      funnelId,
      limit,
      pagination
    };
    $[0] = funnelId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    leads,
    counter
  } = useFunnelLeads(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.funnel.leads_opt_in_date");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "createdAt",
      header: t2,
      widthPercent: 30,
      onRender: _temp
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.funnel.leads_email");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isWsAssistant) {
    t5 = lead_0 => <LeadEmail lead={lead_0} withContactInfo={!isWsAssistant} />;
    $[10] = isWsAssistant;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = {
      key: "email",
      header: t4,
      widthPercent: 30,
      onRender: t5
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("dashboard.funnel.leads_funnel_step_name");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = {
      key: "funnelStepName",
      header: t7,
      widthPercent: 30,
      onRender: _temp2
    };
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t6 || $[21] !== t8) {
    t9 = [t3, t6, t8];
    $[19] = t3;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const columns = t9;
  let t10;
  if ($[23] !== t) {
    t10 = t("dashboard.funnel.leads");
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("dashboard.funnel.leads_title_hint");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11) {
    t12 = <Hint label={t11} />;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== limit || $[30] !== setLimit) {
    t13 = {
      limit,
      setLimit
    };
    $[29] = limit;
    $[30] = setLimit;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== pagination || $[33] !== setPagination) {
    t14 = {
      pagination,
      setPagination
    };
    $[32] = pagination;
    $[33] = setPagination;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {};
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== isWsAssistant) {
    t16 = lead_2 => <MobileCardHeader title={<LeadEmail lead={lead_2} withContactInfo={!isWsAssistant} />} subtitle={<RelativeTime time={lead_2.date} />} action={<div className="text-text-secondary max-w-1/2 shrink-0 truncate">{lead_2.page.funnelStep.name}</div>} />;
    $[36] = isWsAssistant;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("dashboard.funnel.leads_tab.empty.title");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t) {
    t18 = t("dashboard.funnel.leads_tab.empty.description");
    $[40] = t;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t17 || $[43] !== t18) {
    t19 = {
      title: t17,
      description: t18
    };
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== columns || $[46] !== leads || $[47] !== t13 || $[48] !== t14 || $[49] !== t16 || $[50] !== t19) {
    t20 = <Table data={leads} columns={columns} limiter={t13} paginator={t14} actions={t15} renderMobileRow={t16} emptyStateProps={t19} />;
    $[45] = columns;
    $[46] = leads;
    $[47] = t13;
    $[48] = t14;
    $[49] = t16;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== counter || $[53] !== t10 || $[54] !== t12 || $[55] !== t20) {
    t21 = <div><ListingLayout counter={counter} title={t10} help={t12}>{t20}</ListingLayout></div>;
    $[52] = counter;
    $[53] = t10;
    $[54] = t12;
    $[55] = t20;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  return t21;
}
function _temp2(lead_1) {
  return <div className="truncate">{lead_1.page.funnelStep.name}</div>;
}
function _temp(lead) {
  return <span><RelativeTime time={lead.date} /></span>;
}
export default LeadsTab;